import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {MacroSurveyView} from "../components/macroSurvey/MacroSurveyView";

const MacroSurvey: NextPage = () => {
  return <>
    <Head>
      <title>Get Your Macro Plan</title>
    </Head>
    <MacroSurveyView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate', 'macro_survey']),
    }
  }
});

export default MacroSurvey